// @ts-ignore
import { Menu, PageFooter } from '@telia/styleguide';
import AllIcons from '@telia/styleguide/assets/allicons/AllIcons.js';
import { graphql, StaticQuery } from 'gatsby';
import React from 'react';
import Helmet from 'react-helmet';
import { ThemeProvider } from 'styled-components';
import config from '../../config/SiteConfig';
import theme from '../../config/Theme';
import './layout.scss';

const links = [
  { text: 'Open Source', url: '/open-source' },
  { text: 'Blog', url: '/blog' },
  { text: 'Podcast', url: '/podcasts'},
  // { text: 'Books', url: '/books' },
  // { text: 'Events', url: '/events' },
  { text: 'Careers', url: 'https://www.teliacompany.com/en/careers/' },
];

const menuLinks = [
  {
    links,
    heading: { text: 'Telia Engineering', url: 'https://engineering.telia.no' },
  },
  {
    heading: { text: 'Privat', url: 'https://telia.no' },
    links: [],
  },
  {
    heading: { text: 'Bedrift', url: 'https://telia.no/bedrift' },
    links: [],
  },
];
const specialLink = { text: 'Personvern og Cookies', url: 'https://www.telia.no/personvern/' };

export class Layout extends React.PureComponent<{}> {
  public render() {
    const { children } = this.props;

    return (
      <StaticQuery
        query={graphql`
          query LayoutQuery {
            site {
              buildTime(formatString: "DD.MM.YYYY")
            }
          }
        `}
        render={() => (
          <ThemeProvider theme={theme}>
            <React.Fragment>
              { !config.isProd ?
              <Helmet>
                <meta name='robots' content='noindex,nofollow'/>
              </Helmet>
              : null}
              <AllIcons />
              <Menu
                logoUrl='/'
                activeIndex={0}
                menuLinks={menuLinks}
                lockBodyOnMenuOpen
                logoImageDesktopPath='/images/logo.svg'/>
              {children}
              <br/>
              <PageFooter links={links} specialLink={specialLink}/>
            </React.Fragment>
          </ThemeProvider>
        )}
      />
    );
  }
}
